/**
 * Created by PanJiaChen on 16/11/18.
 */

/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validUsername(str) {
  const valid_map = [ 'editor']
  return valid_map.indexOf(str.trim()) >= 0
}

/**
 * @param {string} url
 * @returns {Boolean}
 */
export function validURL(url) {
  const reg = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/
  return reg.test(url)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validLowerCase(str) {
  const reg = /^[a-z]+$/
  return reg.test(str)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validUpperCase(str) {
  const reg = /^[A-Z]+$/
  return reg.test(str)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validAlphabets(str) {
  const reg = /^[A-Za-z]+$/
  return reg.test(str)
}

/**
 * @param {string} email
 * @returns {Boolean}
 */
export function validEmail(email) {
  const reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return reg.test(email)
}

export function isvalidPhone(phone) {
  const reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/
  return reg.test(phone)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function isString(str) {
  if (typeof str === 'string' || str instanceof String) {
    return true
  }
  return false
}

/**
 * @param {Array} arg
 * @returns {Boolean}
 */
export function isArray(arg) {
  if (typeof Array.isArray === 'undefined') {
    return Object.prototype.toString.call(arg) === '[object Array]'
  }
  return Array.isArray(arg)
}

/**
 * 是否合法IP地址
 * @param rule
 * @param value
 * @param callback
 */
export function validateIP(rule, value, callback) {
  if (value === '' || value === undefined || value == null) {
    callback()
  } else {
    const reg = /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/
    if ((!reg.test(value)) && value !== '') {
      callback(new Error('请输入正确的IP地址'))
    } else {
      callback()
    }
  }
}

/* 是否是Email */
export function validateEmail(rule, value, callback) {
  if (value === '' || value === undefined || value == null) {
    callback()
  } else {
    const reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    if ((!reg.test(value)) && value !== '') {
      callback(new Error('请输入正确的电子邮箱'))
    } else {
      callback()
    }
  }
}
/* 是否手机号码或者固话*/
export function validatePhoneTwo(rule, value, callback) {
  const reg = /^((0\d{2,3}-\d{7,8})|(1[34578]\d{9}))$/
  if (value === '' || value === undefined || value == null) {
    callback()
  } else {
    if ((!reg.test(value)) && value !== '') {
      callback(new Error('请输入正确的电话号码或者固话号码'))
    } else {
      callback()
    }
  }
}

/* 是否固话*/
export function validateTelephone(rule, value, callback) {
  const reg = /0\d{2}-\d{7,8}/
  if (value === '' || value === undefined || value == null) {
    callback()
  } else {
    if ((!reg.test(value)) && value !== '') {
      callback(new Error('请输入正确的固话（格式：区号+号码,如010-1234567）'))
    } else {
      callback()
    }
  }
}

/* 是否手机号码*/
export function validatePhone(rule, value, callback) {
  const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
  if (value === '' || value === undefined || value == null) {
    callback()
  } else {
    if ((!reg.test(value)) && value !== '') {
      callback(new Error('请输入正确的手机号码'))
    } else {
      callback()
    }
  }
}

/* 是否身份证号码*/
export function validateIdNo(rule, value, callback) {
  const reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
  if (value === '' || value === undefined || value == null) {
    callback()
  } else {
    if ((!reg.test(value)) && value !== '') {
      callback(new Error('请输入正确的身份证号码'))
    } else {
      callback()
    }
  }
}

/**
 * 银行卡号校验
 * @param rule
 * @param bankno
 * @param callback
 */
export function bankCardCheck(rule, bankno, callback) {
  if (bankno === '' || bankno === undefined || bankno == null) {
    callback(new Error('请输入银行卡号'))
  } else {
    callback()
  }
}

//正数
export function positiveNumberCheck(rule, value, callback) {
  const reg = /^(([1-9]{1}\d*)|(0{1}))(\.\d{1,2})?$/
  if (value === '' || value === undefined || value == null) {
    callback(new Error('请输入数值'))
  } else {
    if ((!reg.test(value)) && value !== '') {
      callback(new Error('请输入保留两位小数的正数'))
    } else {
      callback()
    }
  }
}


/* 日期解析：兼容 'yyyy-MM-dd HH:mm:ss'、'yyyy/MM/dd' 及 Date */
function toDate(value) {
  if (!value) return null
  if (value instanceof Date) return value
  const match = String(value).match(/^(\d{4})[-/](\d{1,2})[-/](\d{1,2})/)
  if (!match) return null
  return new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]))
}

/**
 * 项目预算金额校验：不允许填写 9999、8888、1111 等重复数字的金额
 * @param rule
 * @param value
 * @param callback
 * @param skip 跳过校验（如编辑态字段不可编辑时）
 * @warning 在 el-form 的 rules 中必须用箭头函数包裹后再调用：
 *   `validator: (rule, value, callback) => validateProjectAmount(rule, value, callback)`
 *   因为 async-validator 会以 (rule, value, callback, source, options) 调用校验器，
 *   直接写 `validator: validateProjectAmount` 会把 source(整个表单模型对象) 当成 skip,
 *   导致 skip 恒为真值、校验被静默跳过。
 */
export function validateProjectAmount(rule, value, callback, skip) {
  if (skip) {
    callback()
    return
  }
  if (value === '' || value === undefined || value == null) {
    callback()
    return
  }
  const intPart = String(value).split('.')[0].replace(/^0+/, '')
  if (intPart.length > 1 && /^(\d)\1+$/.test(intPart)) {
    callback(new Error('项目预算不能填写 9999、8888 等重复数字，请填写真实的预算金额'))
    return
  }
  callback()
}

/**
 * 项目有效期校验：项目开始日期至结束日期不能超过 2 年
 * @param rule
 * @param value
 * @param callback
 * @param skip 跳过校验（如编辑态字段不可编辑时）
 * @warning 同 validateProjectAmount，必须用箭头函数包裹后再作为 validator 使用。
 *   另外日期选择器的 trigger 建议配 ['change', 'blur']：面板关闭时会先派发 el.form.change
 *   再派发 el.form.blur，只配 'change' 时错误会被随后的 blur 校验结果覆盖。
 */
export function validateProjectDateRange(rule, value, callback, skip) {
  if (skip) {
    callback()
    return
  }
  if (!value || !value.length || !value[0] || !value[1]) {
    callback()
    return
  }
  const start = toDate(value[0])
  const end = toDate(value[1])
  if (!start || !end) {
    callback()
    return
  }
  const maxEnd = new Date(start.getTime())
  maxEnd.setFullYear(maxEnd.getFullYear() + 2)
  if (end.getTime() > maxEnd.getTime()) {
    callback(new Error('项目有效期不能超过2年，请重新选择项目时间'))
    return
  }
  callback()
}

//特殊字符
export function specialCharacters(rule, value, callback) {
  const reg = '咨询|讲学|录音|录像|演出|表演|工资|奖金|劳务费|提成|绩效|直播'
  if (value === '' || value === undefined || value == null) {
    callback(new Error('请输入'))
  } else {
    let m = value.match(reg)
    if (m != null && m.length > 0) {
      callback(new Error('不能包含"咨询、讲学、录音、录像、演出、表演、工资、奖金、劳务费、直播"字眼信息'))
    } else {
      callback()
    }
  }
}


